
import { useRouter } from 'vue-router';
export default {
   props:{
     title:{  //左侧标题
         type:String,
          required: true,
     },
     more:{  //是否显示更多
         type:Boolean,
         detault:false
     },
     skipPath:{  //跳转
         type:String,
         detault:()=>{
             return ''
         }
     },
     size:{    //字体大小
       type: String || Number ,
       default:14
     },
     colors:{   //字体颜色
       type:String,
       default:'#000'
     },
     backgourdColor:{  //背景颜色
       type:String,
       default:'#fff'
     },
     boundary:{  //字体下标颜色
       type:Boolean,
       default:false
     },
     moreSize:{ //右边字体
       type:String,
       default:'More'
     }
   },
   setup(props:any){     
      const router:any = useRouter()
      const skipClick = ():void=>{     
      props.more?router.push(props.skipPath):''
      }             
      return {
          skipClick
      }
   }
}
